import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Session from '../services/session';

export default class AutoLoginRoute extends Route {
  @service declare session: Session;
  @service declare router: RouterService;

  queryParams = {
    token: { refreshModel: true },
  };

  model(params: { token?: string }) {
    return params.token;
  }

  async afterModel(token: string | undefined) {
    if (this.session.isAuthenticated) {
      this.router.transitionTo('index');
      return;
    }

    if (!token) {
      this.router.transitionTo('login');
      return;
    }

    try {
      await this.session.authenticate('authenticator:better-auth', { token });
      this.router.transitionTo('index');
    } catch {
      this.router.transitionTo('login');
    }
  }
}
